import makeStyles from "@mui/styles/makeStyles";
import { SimpleListItemProps } from "./SimpleListItem.types";

export const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    minHeight: 52,
    borderTop: `1px solid ${theme.palette.grey[200]}`,
    "&:first-child": {
      borderTop: 0,
    },
    [theme.breakpoints.up("lg")]: {
      minHeight: 40,
    },
  },
  rootBullet: (props: SimpleListItemProps) => ({
    paddingLeft: 24,
    "&::before": {
      content: "''",
      position: "absolute",
      left: 0,
      width: 12,
      height: 12,
      marginTop: -3,
      background: props.bulletColor,
      borderRadius: 999,
    },
  }),
  content: {
    flex: "1",
    position: "relative",
  },
  icon: {
    display: "flex",
    alignItems: "center",
    position: "relative",
    "& > svg": {
      width: 20,
      height: 20,
    },
  },
  sizeSmall: {
    fontSize: 12,
    "& > svg": {
      width: 16,
      height: 16,
    },
  },
  sizeLarge: {
    fontSize: 16,
    "& > svg": {
      width: 24,
      height: 24,
    },
  },
}));
